import { Textarea, TextareaProps } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { baseStyledInputStyles } from '../utils/formUtils'

interface Props extends TextareaProps {
  defaultDebounceTime?: number
  value: string | undefined
  setValue: (newValue: string) => void
  isStyled?: boolean
}
export const DebouncedTextArea: React.FC<Props> = ({
  defaultDebounceTime,
  value,
  setValue,
  isStyled,
  ...rest
}) => {
  const [debouncedTerm, setDebouncedTerm] = useState(value)
  const debounceTime = defaultDebounceTime ?? 600

  useEffect(() => {
    const timer = setTimeout(() => setValue(debouncedTerm ?? ''), debounceTime)
    return () => clearTimeout(timer)
  }, [debouncedTerm])

  return (
    <Textarea
      variant={'outline'}
      fontSize="md"
      value={debouncedTerm}
      onChange={(e) => setDebouncedTerm(e.target.value)}
      {...rest}
      {...(isStyled ? baseStyledInputStyles : {})}
    />
  )
}
